import { createSlice } from "@reduxjs/toolkit";

import {
  getPaymentThunk,
  createPaymentThunk,
  updatePaymentThunk,
  deletePaymentThunk,
} from "state/action/payment";

// Initial state
const initialState = {
  // Get Payment inisial state
  getPayment: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Create Payment inisial state
  createPayment: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Update Payment inisial state
  updatePayment: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Delete Payment inisial state
  deletePayment: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Payment object value
  payment_object_value: "",
  createPaymentInputBody: {
    payment_method: "",
    invoice_id: "",
    contract_id:"",
    tenant_id:"",
    amount: "",
    payment_date: "",
    note: "",
    proof_of_payment: {
      file:"",
      url:""
    }
  },
  selectedPayment: {},
  editPaymentInputBody: {
    status: ""
  }
};

export const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    setGetPaymentObjectValue: (state, action) => {
      return {
        ...state,
        payment_object_value: action.payload,
      };
    },
    setSelectedPayment: (state, action) => {
        return {
          ...state,
          selectedPayment: action.payload,
        };
      },
    setCreatePaymentInputBody: (state, action) => {
        return {
          ...state,
          createPaymentInputBody: action.payload,
        };
      },
      setEditPaymentInputBody: (state, action) => {
        return {
          ...state,
          editPaymentInputBody: action.payload,
        };
      },
    // note: clear state
    setClearGetPaymentObjectValue: (state, _) => {
      return {
        ...state,
        payment_object_value: "",
      };
    },
    setClearGetPayment: (state, _) => {
      return {
        ...state,
        getPayment: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearCreatePayment: (state, _) => {
      return {
        ...state,
        createPayment: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearUpdatePayment: (state, _) => {
      return {
        ...state,
        updatePayment: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearDeletePayment: (state, _) => {
      return {
        ...state,
        deletePayment: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearAllPaymentState: (state, _) => {
      return {
        ...state,
        // Get Payment inisial state
        getPayment: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Create Payment inisial state
        createPayment: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Update Payment inisial state
        updatePayment: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Delete Payment inisial state
        deletePayment: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Payment object value
        Payment_object_value: "",
      };
    },
  },
  extraReducers(builder) {
    builder
      // Get Payment reducer
      .addCase(getPaymentThunk.pending, (state, _) => {
        return {
          ...state,
          getPayment: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getPaymentThunk.fulfilled, (state, action) => {
        return {
          ...state,
          getPayment: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getPaymentThunk.rejected, (state, action) => {
        return {
          ...state,
          getPayment: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // Create Payment reducer
      .addCase(createPaymentThunk.pending, (state, _) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createPaymentThunk.fulfilled, (state, action) => {
        return {
          ...state,
          register: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createPaymentThunk.rejected, (state, action) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // update Payment reducer
      .addCase(updatePaymentThunk.pending, (state, _) => {
        return {
          ...state,
          updatePayment: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updatePaymentThunk.fulfilled, (state, action) => {
        return {
          ...state,
          updatePayment: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updatePaymentThunk.rejected, (state, action) => {
        return {
          ...state,
          updatePayment: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      });
  },
});

export const paymentAction = {
  ...paymentSlice.actions,
  getPaymentThunk,
  createPaymentThunk,
  updatePaymentThunk,
  deletePaymentThunk,
};

export function selectPaymentObjectValue(state) {
  return state?.payment?.payment_object_value;
}

export function selectPayment(state) {
  return state?.payment;
}

export default paymentSlice.reducer;
